import * as yup from 'yup';

export const loginValidationSchema = yup.object({
    email: yup
        .string()
        .email('El email no es valido')
        .required('El email es requerido'),
    password: yup
        .string()
        .min(8, 'La contraseña debe tener al menos 8 caracteres.')
        .required('La contraseña es requerida'),
});